import { useColors } from "@certn/cascadia-react";
import { getTextStyle } from "@certn/cascadia-react/foundations/typography/styles";
import { CascadiaColor, CascadiaTypographyStyle } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import { useMemo } from "react";
import { mergeProps } from "react-aria";
import { Link as AriaLink, LinkProps } from "react-aria-components";

interface Props extends Omit<LinkProps, "style"> {
  style?: CascadiaTypographyStyle;
  color?: CascadiaColor;
  testID?: string;
}

export function Link(props: Props) {
  const {
    testID = "link",
    style = "form/body-primary-link",
    color = "text-info",
    ...linkProps
  } = props;

  const colors = useColors();

  const className = useMemo(() => {
    return css(styles.link, getTextStyle(style), {
      color: colors[color],
    });
  }, [colors]);

  return (
    <AriaLink data-testid={testID} {...mergeProps(linkProps, { className })} />
  );
}

const styles = {
  link: css({
    borderRadius: "var(--border-radius-2)",
    outline: "none",
    cursor: "pointer",
    "&[data-focused]": {
      boxShadow: "var(--focus-action)",
    },
  }),
};
